import {Selectors} from '../Settings';

/**
 * Testimonials
 */
export default class Testimonials {
    constructor($testimonialsSelector) {
        this.$testimonialsSelector = $testimonialsSelector;
        this.initSlider();
    }

    initSlider() {
        this.$testimonialsSelector.addClass('owl-carousel');
        this.$testimonialsSelector.owlCarousel({
            items: 1,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            mouseDrag: false,
            touchDrag: false,
            autoplay: true,
            autoplayHoverPause: true,
            loop: true,
            dots: true
        });
    }
}